import { api } from '../lib/api';
import type { Overview } from './models';

export const statsApi = {
  overview: () => api.get<Overview>('/stats/overview'),
};
